export function BrandMark({ compact = false }) {
  return (
    <a className="brand" href="#top" aria-label="BOLT PROTECT — в начало страницы">
      <svg className="brand__mark" viewBox="0 0 48 56" aria-hidden="true">
        <path
          d="M24 2.5C17.2 7.2 10.7 8.2 4.5 8.2v17.1c0 14.1 8.5 23 19.5 28.2 11-5.2 19.5-14.1 19.5-28.2V8.2C37.3 8.2 30.8 7.2 24 2.5Z"
          fill="none"
          stroke="currentColor"
          strokeWidth="2.2"
          strokeLinejoin="round"
        />
        <path
          d="M27.4 11.7 14.7 30.4h8l-2 13.9 12.8-19.1h-8.1l2-13.5Z"
          fill="currentColor"
          stroke="currentColor"
          strokeLinejoin="round"
        />
      </svg>
      {compact ? null : (
        <span className="brand__wordmark">
          <span>BOLT</span> PROTECT
        </span>
      )}
    </a>
  );
}
